import React from 'react';
import { generatePath, Link } from 'react-router-dom';

import { ADD_YOUR_COMPANY_PAGE_ROUTE, MAIN_PAGE_ROUTE } from 'client/constants/routes';
import { useAppSelector, useTranslation } from 'client/hooks';
import { selectLang } from 'client/redux/settings/selectors';

import css from './AddYourCompanyBtnLink.module.scss';

type Props = {
  from?: string;
};

const AddYourCompanyBtnLink: React.FC<Props> = ({ from }) => {
  const { translate } = useTranslation();
  const lang = useAppSelector(selectLang);

  return (
    <div className={css.wrapper}>
      <Link
        to={{
          pathname: generatePath(ADD_YOUR_COMPANY_PAGE_ROUTE, { lang }),
          state: { from: from ?? MAIN_PAGE_ROUTE.replace(':id?', '').replace(':lang', lang) },
        }}
        className={css.button}
      >
        <div className={css.inner}>{translate('commonButtons.addYourCompany')}</div>
        <div className={css.buttonBlur}></div>
      </Link>
      <div className={css.wrapperBlur}></div>
    </div>
  );
};

export default AddYourCompanyBtnLink;
